<template>
    <div class="price-wrapper mb-2">
        <!--
        <div v-if="offer.commission && offer.commission.percentage >= 10" class="badge badge-primary mr-1 mb-1">
            Stay Reward 5%
        </div>
        -->
        <div v-if="offer.rateCode == 'PRO' || offer.rateCode == 'SPC'" class="badge badge-success">
            Special Deal
        </div>
        <div><small>{{ dateDifference(offer.checkInDate, offer.checkOutDate) }} {{ $tc('night', dateDifference(offer.checkInDate, offer.checkOutDate)) }}, {{ offer.guests.adults }} {{ $tc('adult', offer.guests.adults) }}</small></div>
        <div class="display-4" v-if="offer.roomQuantity > 1">
            <template v-if="offer.price.total">
                {{ formatPrice(offer.price.total * offer.roomQuantity, offer.price.currency, exchangerates) }}
            </template>
            <template v-else>
                {{ formatPrice(offer.price.base * offer.roomQuantity, offer.price.currency, exchangerates) }}
            </template>
        </div>
        <div class="display-4" v-else>
            <template v-if="offer.price.total">
                {{ formatPrice(offer.price.total, offer.price.currency, exchangerates) }}
            </template>
            <template v-else>
                {{ formatPrice(offer.price.base, offer.price.currency, exchangerates) }}
            </template>
        </div>
        <div>
            <template v-if="offer.price.total">
                <small v-b-modal="'modal-' + offer.id">Includes taxes and fees</small>
            </template>
            <template v-else>
                <small v-b-modal="'modal-' + offer.id"><strong>Excluding taxes and fees</strong></small>
            </template>
            <b-modal :id="'modal-' + offer.id" title="Price details" ok-only>
                <table class="table table-compact table-borderless">
                    <tr>
                        <td>
                            <div>x nights</div>
                        </td>
                        <td class="text-right"></td>
                    </tr>
                    <tr>
                        <td>
                            <div>Taxes &amp; fees</div>
                        </td>
                        <td class="text-right"></td>
                    </tr>
                    <tr>
                        <td>
                            <div>Local tax</div>
                        </td>
                        <td class="text-right"></td>
                    </tr>
                </table>
                <table class="table table-compact">
                    <tr>
                        <td class="font-weight-bold">Total</td>
                        <td class="font-weight-bold text-right">
                            {{ formatPrice(offer.price.total * offer.roomQuantity, offer.price.currency, exchangerates) }}
                        </td>
                    </tr>
                </table>
            </b-modal>
        </div>
    </div>
</template>

<script>
    import dayjs from 'dayjs'

    export default {
        name: 'Price',
        props: {
            offer: {
                type: Object,
                required: true
            },
            exchangerates: {
                type: Object,
                required: true
            }
        },
        methods: {
            formatPrice(value, currency, exchangerates) {

                if (Object.keys(exchangerates).length > 0 && currency) {
                    let rate = value * exchangerates[currency].rate;
                    return this.currency(exchangerates[currency].target) + (rate/1).toFixed(exchangerates[currency].targetDecimalPlaces).replace('.', ',');
                }

                let val = (value/1).toFixed(2).replace('.', ',')
                return this.currency(currency) + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },
            dateDifference(date1, date2) {
                var a = dayjs(date2, "YYYY-MM-DD");
                var b = dayjs(date1, "YYYY-MM-DD");
                return a.diff(b, 'days');
            },
            currency(iso) {
                if (iso == 'EUR') {
                    return '€';
                }
                if (iso == 'USD') {
                    return '$';
                }
                if (iso == 'AUD') {
                    return '$';
                }
                if (iso == 'CAD') {
                    return '$';
                }
                if (iso == 'GBP') {
                    return '£';
                }
            },
        },
        i18n: { // `i18n` option, setup locale info for component
            messages: {
                en: {
                    night: 'night | nights',
                    adult: 'adult | adults'
                }
            },
        }
    }
</script>

<style scoped>

</style>